/**
 * «Легло ли на карту хоть что-нибудь».
 *
 * Прод 2026-08-09: владелец включил четыре инструмента и не увидел ни одной
 * линии. Данные были все — не было ЧЕГО рисовать: изотермы 5 °C нет в воде
 * 7,6…11,5 °C, изобат через 10 м нет там, где мельче 1460 м не бывает. Легенда
 * при этом перечисляла инструменты так, будто они на карте есть.
 *
 * Считать «попадает ли порог в диапазон поля» отдельной формулой было бы вторым
 * ответом на тот же вопрос — и он неизбежно разошёлся бы с первым. Спрашиваем
 * сам результат: в построенной геометрии есть точки или нет.
 */

type AnyGeometry =
  | { type: 'MultiLineString'; coordinates: unknown[] }
  | { type: string; coordinates?: unknown }

/** Есть ли в фиче хоть одна линия. Пустая MultiLineString — обычный исход
 *  marching squares: уровень не пересёк поле. */
export function featureDrawn(
  f: { geometry?: AnyGeometry | null } | null | undefined,
): boolean {
  const coords = f?.geometry?.coordinates
  return Array.isArray(coords) && coords.length > 0
}

/** То же для коллекции: хотя бы одна фича с геометрией. */
export function collectionDrawn(
  fc: { features?: Array<{ geometry?: AnyGeometry | null }> } | null | undefined,
): boolean {
  return (fc?.features ?? []).some(featureDrawn)
}
